import { render, staticRenderFns } from "./DetalheServico.vue?vue&type=template&id=f3689cb4"
import script from "./DetalheServico.vue?vue&type=script&lang=js"
export * from "./DetalheServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports